import { render, staticRenderFns } from "./PageAdminOpportunityLabels.vue?vue&type=template&id=f4fbe03a"
import script from "./PageAdminOpportunityLabels.vue?vue&type=script&lang=js"
export * from "./PageAdminOpportunityLabels.vue?vue&type=script&lang=js"
import style0 from "./PageAdminOpportunityLabels.vue?vue&type=style&index=0&id=f4fbe03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports